// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.styles_container__-qKGz {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative; }

.styles_backButton__Pk3to {
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: white;
  border: none;
  border-radius: 0.5rem;
  color: #808080b8;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
  font-weight: 500; }
  .styles_backButton__Pk3to svg {
    width: 20px;
    height: 20px; }
  .styles_backButton__Pk3to:hover {
    background: #80808012;
    border-color: #8080805c;
    transform: translateX(-2px); }
  .styles_backButton__Pk3to:active {
    transform: translateX(-1px); }

.styles_gridContainer__ZbeRs {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 2rem;
  height: 100%;
  padding: 2rem;
  padding-top: 5rem;
  padding-bottom: 5rem;
  overflow: hidden;
  min-width: 0; }
  @media (max-width: 1024px) {
    .styles_gridContainer__ZbeRs {
      grid-template-columns: 1fr;
      overflow-y: auto; } }

.styles_pageHeader__V76eP {
  font-size: 1.5rem;
  font-weight: 700;
  color: #808080e6;
  margin: 0 0 0.35rem 0;
  line-height: 1.3; }

.styles_tierBenefit__G9ePJ {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.5rem; }

.styles_tierBenefitIcon__GR0pZ {
  font-size: 1.15rem;
  line-height: 1; }

.styles_tierBenefitLabel__U0v3y {
  font-size: 0.95rem;
  color: #808080b8;
  font-weight: 500; }
  .styles_tierBenefitLabel__U0v3y p {
    margin: 0; }

.styles_leftColumn__L4U7F {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  min-width: 0;
  justify-content: flex-start; }
  .styles_leftColumn__L4U7F .styles_card__4gC5V {
    width: 90%;
    min-width: 0;
    border: 1px solid #808080b8;
    border-radius: 0.6rem;
    padding: unset !important;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
    margin: 0.75rem auto;
    background: white;
    box-shadow: 0 1px 2px #808080b8;
    min-height: 15rem; }
    .styles_leftColumn__L4U7F .styles_card__4gC5V:hover {
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08); }
    .styles_leftColumn__L4U7F .styles_card__4gC5V > div:last-child {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0.75rem 1rem; }
      .styles_leftColumn__L4U7F .styles_card__4gC5V > div:last-child button {
        margin-top: 2rem;
        padding: 1rem 3rem;
        font-size: 1.1rem;
        width: 100%;
        max-width: 300px; }
    .styles_leftColumn__L4U7F .styles_card__4gC5V.styles_selected__tz1wd {
      border: 2px solid #72abab;
      box-shadow: 0 0 0 1px #72abab5c, 0 8px 24px rgba(0, 0, 0, 0.12);
      background: linear-gradient(to bottom, #73abab1a, white); }
      .styles_leftColumn__L4U7F .styles_card__4gC5V.styles_selected__tz1wd h2,
      .styles_leftColumn__L4U7F .styles_card__4gC5V.styles_selected__tz1wd .card-header {
        color: #72abab; }
      .styles_leftColumn__L4U7F .styles_card__4gC5V.styles_selected__tz1wd .styles_mainText__UGxRG {
        color: #808080e6; }
      .styles_leftColumn__L4U7F .styles_card__4gC5V.styles_selected__tz1wd .styles_inclusionsItem__IPYY\\+ {
        color: #808080e6; }

.styles_subscribeContent__SAvJR {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }
  .styles_subscribeContent__SAvJR h2 {
    margin: 0.5rem 0rem; }

.styles_mainText__UGxRG {
  font-size: 1.25rem;
  line-height: 1.5;
  color: #808080b8;
  font-weight: 500;
  margin-bottom: 0.25rem; }

.styles_inclusionsList__MJmJ7 {
  list-style: disc;
  padding-left: 1.25rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem; }

.styles_inclusionsItem__IPYY\\+ {
  color: #808080b8;
  font-size: 0.9rem;
  line-height: 1; }
  .styles_inclusionsItem__IPYY\\+ p {
    margin: 0;
    display: inline;
    color: #808080b8;
    font-size: 1.25rem;
    line-height: 1; }

.styles_benefitsSection__T5q4T {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0; }

.styles_benefitItem__GcoL3 {
  display: flex;
  gap: 1.25rem;
  align-items: center;
  text-align: left; }

.styles_benefitIcon__S3Ehn {
  font-size: 2rem;
  flex-shrink: 0;
  line-height: 1; }

.styles_benefitTitle__Th1hJ {
  font-size: 1.1rem;
  color: #808080e6;
  line-height: 1.4; }

.styles_benefitDesc__Cl498 {
  font-size: 0.95rem;
  color: #8080808a;
  line-height: 1.6; }

.styles_footerText__WA3lT {
  text-align: center;
  font-size: 0.95rem;
  color: #8080808a;
  font-style: italic;
  margin-top: 0.5rem; }

.styles_rightColumn__YDB2- {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 1rem 0; }

.styles_summaryCard__BvQyT {
  width: 100%;
  max-width: 35rem;
  height: fit-content;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #8080808a; }
  .styles_summaryCard__BvQyT h2 {
    text-decoration: underline; }
  .styles_summaryCard__BvQyT .card-header {
    font-size: 1.5rem;
    padding: 1.5rem; }

.styles_summaryContent__XCA\\+J {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem; }

.styles_summaryItem__s6GqQ {
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }
  .styles_summaryItem__s6GqQ p:first-child {
    font-size: 0.9rem;
    color: #808080e6;
    font-weight: 700; }
  .styles_summaryItem__s6GqQ p:last-child {
    font-size: 1rem;
    color: #808080b8; }

.styles_summaryDivider__4MOlU {
  height: 1px;
  background: #8080802e;
  margin: 0.5rem 0; }

.styles_benefitsList__8fIhP {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem; }
  .styles_benefitsList__8fIhP li {
    padding-left: 1.5rem;
    position: relative;
    color: #808080b8;
    font-size: 0.95rem;
    line-height: 1.5; }
    .styles_benefitsList__8fIhP li:before {
      content: "✓";
      position: absolute;
      left: 0;
      color: #10b981;
      font-weight: bold; }

.styles_totalSection__\\+9-tr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: #80808012;
  border-radius: 0.5rem;
  margin-top: 0.5rem; }

.styles_totalLabel__QkwN4 {
  font-size: 1.1rem;
  color: black; }

.styles_totalAmount__OYMbK {
  font-size: 1.5rem;
  color: black; }

.styles_tierFooter__MllNc {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.12);
  padding: 1rem 2rem;
  z-index: 100;
  animation: styles_slideUp__rt3iL 0.25s ease-out; }

@keyframes styles_slideUp__rt3iL {
  from {
    opacity: 0;
    transform: translateY(100%); }
  to {
    opacity: 1;
    transform: translateY(0); } }

.styles_tierFooterContent__1iHQC {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap; }
  @media (max-width: 600px) {
    .styles_tierFooterContent__1iHQC {
      flex-direction: column;
      align-items: stretch; } }

.styles_tierFooterSummary__gUmAX {
  display: flex;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap; }

.styles_tierFooterPlan__b2-Gu {
  font-size: 1.1rem;
  color: #808080e6; }

.styles_tierFooterPrice__oQE6I {
  font-size: 1rem;
  color: #808080b8; }

.styles_tierFooterButton__891kQ {
  min-width: 200px;
  padding: 0.875rem 1.75rem !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  border: 2px solid #72abab !important;
  background: #72abab !important;
  color: white !important;
  border-radius: 0.5rem;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.15s ease; }
  .styles_tierFooterButton__891kQ:hover:not(:disabled) {
    background: #72ababb8 !important;
    border-color: #72ababb8 !important;
    transform: translateY(-1px); }
  .styles_tierFooterButton__891kQ svg {
    color: white;
    font-size: 1.5rem; }
  .styles_tierFooterButton__891kQ:active:not(:disabled) {
    transform: translateY(0); }

.styles_drawer__cxrWR {
  overflow-y: auto; }

.styles_paymentsContainer__EwoQM {
  max-width: 75%;
  margin: 3rem auto;
  overflow-y: auto; }
  .styles_paymentsContainer__EwoQM .styles_paymentsCard__pNHcz {
    padding: 5%; }
  .styles_paymentsContainer__EwoQM h2 {
    font-size: 2.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/membership/components/screens/membership-registration/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,gBCHgB;EDIhB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB,EAAA;EAflB;IAkBI,WAAW;IACX,YAAY,EAAA;EAnBhB;IAuBI,qBCrBa;IDsBb,uBCnBc;IDoBd,2BAA2B,EAAA;EAzB/B;IA6BI,2BAA2B,EAAA;;AAI/B;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY,EAAA;EAEZ;IAXF;MAYI,0BAA0B;MAC1B,gBAAgB,EAAA,EAEnB;;AAED;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBC5CgB;ED6ChB,qBAAqB;EACrB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,gBChEgB;EDiEhB,gBAAgB,EAAA;EAHlB;IAMI,SAAS,EAAA;;AAIb;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B,EAAA;EAN7B;IASI,UAAU;IACV,YAAY;IACZ,2BCnFc;IDoFd,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,yGAAyG;IACzG,oBAAoB;IACpB,iBAAiB;IACjB,+BC1Fc;ID2Fd,iBAAiB,EAAA;IAnBrB;MAsBM,yCAAyC,EAAA;IAtB/C;MAyBM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB;MACtB,qBAAqB,EAAA;MA7B3B;QAgCQ,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,WAAW;QACX,gBAAgB,EAAA;IApCxB;MAyCM,yBC3Fc;MD4Fd,+DAAmE;MACnE,wDAA4D,EAAA;MA3ClE;;QA+CQ,cCjGY,EAAA;MDkDpB;QAmDQ,gBC1HU,EAAA;MDuElB;QAuDQ,gBC9HU,EAAA;;ADoIlB;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EAJb;IAMI,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBClJgB;EDmJhB,gBAAgB;EAChB,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,gBCjKgB;EDkKhB,iBAAiB;EACjB,cAAc,EAAA;EAHhB;IAMI,SAAS;IACT,eAAe;IACf,gBCxKc;IDyKd,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB,EAAA;;AAGlB;EACE,eAAe;EACf,cAAc;EACd,cAAc,EAAA;;AAGhB;EACE,iBAAiB;EACjB,gBClMgB;EDmMhB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,gBC1MgB;ED2MhB,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBCjNgB;EDkNhB,kBAAkB;EAClB,kBAAkB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,uBCpOgB,EAAA;ED+NlB;IAOI,0BAA0B,EAAA;EAP9B;IAWI,iBAAiB;IACjB,eAAe,EAAA;;AAInB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EAHb;IAMI,iBAAiB;IACjB,gBC3Pc;ID4Pd,gBAAgB,EAAA;EARpB;IAYI,eAAe;IACf,gBClQc,EAAA;;ADsQlB;EACE,WAAW;EACX,qBC5QgB;ED6QhB,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW,EAAA;EANb;IASI,oBAAoB;IACpB,kBAAkB;IAClB,gBCvRc;IDwRd,kBAAkB;IAClB,gBAAgB,EAAA;IAbpB;MAgBM,YAAS;MACT,kBAAkB;MAClB,OAAO;MACP,cAAc;MACd,iBAAiB,EAAA;;AAKvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,qBChTe;EDiTf,qBAAqB;EACrB,kBAAkB,EAAA;;AAGpB;EACE,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,+CAAiC,EAAA;;AAGnC;EACE;IACE,UAAU;IACV,2BAA2B,EAAA;EAE7B;IACE,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAI5B;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe,EAAA;EAEf;IATF;MAUI,sBAAsB;MACtB,oBAAoB,EAAA,EAEvB;;AAED;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe,EAAA;;AAGjB;EACE,iBAAiB;EACjB,gBCvWgB,EAAA;;AD0WlB;EACE,eAAe;EACf,gBC7WgB,EAAA;;ADgXlB;EACE,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAwC;EACxC,8BAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,oFAAoF,EAAA;EATtF;IAYI,gCAAoC;IACpC,kCAAsC;IACtC,2BAA2B,EAAA;EAd/B;IAkBE,YAAY;IACZ,iBAAiB,EAAA;EAnBnB;IAsBI,wBAAwB,EAAA;;AAI5B;EACE,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB,EAAA;EAHlB;IAMI,WAAW,EAAA;EANf;IAUI,iBAAiB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  position: relative;\n}\n\n.backButton {\n  position: absolute;\n  top: 1.5rem;\n  left: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.25rem;\n  background: white;\n  border: none;\n  border-radius: 0.5rem;\n  color: $grey72;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 1rem;\n  font-weight: 500;\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  &:hover {\n    background: $grey7;\n    border-color: $grey36;\n    transform: translateX(-2px);\n  }\n\n  &:active {\n    transform: translateX(-1px);\n  }\n}\n\n.gridContainer {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 2rem;\n  height: 100%;\n  padding: 2rem;\n  padding-top: 5rem;\n  padding-bottom: 5rem; // space for fixed tier footer\n  overflow: hidden;\n  min-width: 0;\n\n  @media (max-width: 1024px) {\n    grid-template-columns: 1fr;\n    overflow-y: auto;\n  }\n}\n\n.pageHeader {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: $grey90;\n  margin: 0 0 0.35rem 0;\n  line-height: 1.3;\n}\n\n.tierBenefit {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin-top: 0.5rem;\n}\n\n.tierBenefitIcon {\n  font-size: 1.15rem;\n  line-height: 1;\n}\n\n.tierBenefitLabel {\n  font-size: 0.95rem;\n  color: $grey72;\n  font-weight: 500;\n\n  p {\n    margin: 0;\n  }\n}\n\n.leftColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow-y: auto;\n  min-width: 0;\n  justify-content: flex-start;\n\n  .card {\n    width: 90%;\n    min-width: 0;\n    border: 1px solid $grey72;\n    border-radius: 0.6rem;\n    padding: unset !important;\n    cursor: pointer;\n    transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, transform 0.2s ease;\n    margin: 0.75rem auto;\n    background: white;\n    box-shadow: 0 1px 2px $grey72;\n    min-height: 15rem;\n\n    &:hover {\n      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);\n    }\n    & > div:last-child {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      padding: 0.75rem 1rem;\n\n      & button {\n        margin-top: 2rem;\n        padding: 1rem 3rem;\n        font-size: 1.1rem;\n        width: 100%;\n        max-width: 300px;\n      }\n    }\n\n    &.selected {\n      border: 2px solid $ocean_blue;\n      box-shadow: 0 0 0 1px $ocean_blue36, 0 8px 24px rgba(0, 0, 0, 0.12);\n      background: linear-gradient(to bottom, $ocean_blue10, white);\n\n      :global(h2),\n      :global(.card-header) {\n        color: $ocean_blue;\n      }\n\n      .mainText {\n        color: $grey90;\n      }\n\n      .inclusionsItem {\n        color: $grey90;\n      }\n    }\n  }\n}\n\n.subscribeContent {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  h2 {\n    margin: 0.5rem 0rem;\n  }\n}\n\n.mainText {\n  font-size: 1.25rem;\n  line-height: 1.5;\n  color: $grey72;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.inclusionsList {\n  list-style: disc;\n  padding-left: 1.25rem;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.inclusionsItem {\n  color: $grey72;\n  font-size: 0.9rem;\n  line-height: 1;\n\n  p {\n    margin: 0;\n    display: inline;\n    color: $grey72;\n    font-size: 1.25rem;\n    line-height: 1;\n  }\n}\n\n.benefitsSection {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 0;\n}\n\n.benefitItem {\n  display: flex;\n  gap: 1.25rem;\n  align-items: center;\n  text-align: left;\n}\n\n.benefitIcon {\n  font-size: 2rem;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.benefitTitle {\n  font-size: 1.1rem;\n  color: $grey90;\n  line-height: 1.4;\n}\n\n.benefitDesc {\n  font-size: 0.95rem;\n  color: $grey54;\n  line-height: 1.6;\n}\n\n.footerText {\n  text-align: center;\n  font-size: 0.95rem;\n  color: $grey54;\n  font-style: italic;\n  margin-top: 0.5rem;\n}\n\n\n.rightColumn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 1rem 0;\n}\n\n.summaryCard {\n  width: 100%;\n  max-width: 35rem;\n  height: fit-content;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: $grey54;\n  h2 {\n    text-decoration: underline;\n  }\n\n  :global(.card-header) {\n    font-size: 1.5rem;\n    padding: 1.5rem;\n  }\n}\n\n.summaryContent {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.summaryItem {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n\n  p:first-child {\n    font-size: 0.9rem;\n    color: $grey90;\n    font-weight: 700;\n  }\n\n  p:last-child {\n    font-size: 1rem;\n    color: $grey72;\n  }\n}\n\n.summaryDivider {\n  height: 1px;\n  background: $grey18;\n  margin: 0.5rem 0;\n}\n\n.benefitsList {\n  list-style: none;\n  padding: 0;\n  margin: 0.5rem 0 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n\n  li {\n    padding-left: 1.5rem;\n    position: relative;\n    color: $grey72;\n    font-size: 0.95rem;\n    line-height: 1.5;\n\n    &:before {\n      content: \"✓\";\n      position: absolute;\n      left: 0;\n      color: #10b981;\n      font-weight: bold;\n    }\n  }\n}\n\n.totalSection {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  background: $grey7;\n  border-radius: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.totalLabel {\n  font-size: 1.1rem;\n  color: black;\n}\n\n.totalAmount {\n  font-size: 1.5rem;\n  color: black;\n}\n\n.tierFooter {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: white;\n  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.12);\n  padding: 1rem 2rem;\n  z-index: 100;\n  animation: slideUp 0.25s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tierFooterContent {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n\n  @media (max-width: 600px) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n.tierFooterSummary {\n  display: flex;\n  align-items: baseline;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.tierFooterPlan {\n  font-size: 1.1rem;\n  color: $grey90;\n}\n\n.tierFooterPrice {\n  font-size: 1rem;\n  color: $grey72;\n}\n\n.tierFooterButton {\n  min-width: 200px;\n  padding: 0.875rem 1.75rem !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  border: 2px solid $ocean_blue !important;\n  background: $ocean_blue !important;\n  color: white !important;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: $ocean_blue72 !important;\n    border-color: $ocean_blue72 !important;\n    transform: translateY(-1px);\n  }\n  \nsvg {\n  color: white;\n  font-size: 1.5rem;\n}\n  &:active:not(:disabled) {\n    transform: translateY(0);\n  }\n}\n\n.drawer {\n  overflow-y: auto;\n}\n\n.paymentsContainer {\n  max-width: 75%;\n  margin: 3rem auto;\n  overflow-y: auto;\n  \n  .paymentsCard {\n    padding: 5%;\n  }\n\n  h2 {\n    font-size: 2.5rem;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__-qKGz`,
	"backButton": `styles_backButton__Pk3to`,
	"gridContainer": `styles_gridContainer__ZbeRs`,
	"pageHeader": `styles_pageHeader__V76eP`,
	"tierBenefit": `styles_tierBenefit__G9ePJ`,
	"tierBenefitIcon": `styles_tierBenefitIcon__GR0pZ`,
	"tierBenefitLabel": `styles_tierBenefitLabel__U0v3y`,
	"leftColumn": `styles_leftColumn__L4U7F`,
	"card": `styles_card__4gC5V`,
	"selected": `styles_selected__tz1wd`,
	"mainText": `styles_mainText__UGxRG`,
	"inclusionsItem": `styles_inclusionsItem__IPYY+`,
	"subscribeContent": `styles_subscribeContent__SAvJR`,
	"inclusionsList": `styles_inclusionsList__MJmJ7`,
	"benefitsSection": `styles_benefitsSection__T5q4T`,
	"benefitItem": `styles_benefitItem__GcoL3`,
	"benefitIcon": `styles_benefitIcon__S3Ehn`,
	"benefitTitle": `styles_benefitTitle__Th1hJ`,
	"benefitDesc": `styles_benefitDesc__Cl498`,
	"footerText": `styles_footerText__WA3lT`,
	"rightColumn": `styles_rightColumn__YDB2-`,
	"summaryCard": `styles_summaryCard__BvQyT`,
	"summaryContent": `styles_summaryContent__XCA+J`,
	"summaryItem": `styles_summaryItem__s6GqQ`,
	"summaryDivider": `styles_summaryDivider__4MOlU`,
	"benefitsList": `styles_benefitsList__8fIhP`,
	"totalSection": `styles_totalSection__+9-tr`,
	"totalLabel": `styles_totalLabel__QkwN4`,
	"totalAmount": `styles_totalAmount__OYMbK`,
	"tierFooter": `styles_tierFooter__MllNc`,
	"slideUp": `styles_slideUp__rt3iL`,
	"tierFooterContent": `styles_tierFooterContent__1iHQC`,
	"tierFooterSummary": `styles_tierFooterSummary__gUmAX`,
	"tierFooterPlan": `styles_tierFooterPlan__b2-Gu`,
	"tierFooterPrice": `styles_tierFooterPrice__oQE6I`,
	"tierFooterButton": `styles_tierFooterButton__891kQ`,
	"drawer": `styles_drawer__cxrWR`,
	"paymentsContainer": `styles_paymentsContainer__EwoQM`,
	"paymentsCard": `styles_paymentsCard__pNHcz`
};
export default ___CSS_LOADER_EXPORT___;
